export const SettingsModal = ({ sfxOn, setSfxOn, isMusicOn, toggleMusic, vibrationOn, setVibrationOn, isPro, introOn, setIntroOn, outroOn, setOutroOn, adUnlocked, watchAdToUnlock, onClose }) => {
  const settingsUnlocked = isPro || (adUnlocked && adUnlocked.settings);

  const items = [
    { label: 'Sound Effects', value: sfxOn, set: (v) => { setSfxOn(v); localStorage.setItem('mimiSfx', v); }, id: 'sfx', locked: false },
    { label: 'Background Music', value: isMusicOn, set: toggleMusic, id: 'bgm', locked: false },
    { label: 'Vibration', value: vibrationOn, set: (v) => { setVibrationOn(v); localStorage.setItem('mimiVibration', v); }, id: 'vibration', locked: false },
    { label: 'Intro Video', value: introOn, set: (v) => { setIntroOn(v); localStorage.setItem('mimiIntro', v); }, id: 'intro', locked: !settingsUnlocked },
    { label: 'Outro Video', value: outroOn, set: (v) => { setOutroOn(v); localStorage.setItem('mimiOutro', v); }, id: 'outro', locked: !settingsUnlocked },
  ];

  return (
    <div className="absolute inset-0 z-[60] flex items-center justify-center bg-black/60" data-testid="settings-overlay">
      <div className="bg-slate-800 rounded-3xl p-6 w-72 shadow-2xl border border-white/10">
        <h2 className="text-2xl font-bold text-white mb-5 text-center" style={{ fontFamily: 'Fredoka, sans-serif' }}>Settings</h2>
        <div className="space-y-4">
          {items.map((item) => (
            <div key={item.id} className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <span className={`text-sm ${item.locked ? 'text-white/40' : 'text-white/80'}`} style={{ fontFamily: 'Nunito, sans-serif' }}>{item.label}</span>
                {item.locked && (
                  <span className="text-[9px] font-bold text-amber-400 px-1.5 py-0.5 rounded-full"
                    style={{ background: 'linear-gradient(135deg, rgba(251,191,36,0.2), rgba(245,158,11,0.2))', fontFamily: 'Fredoka, sans-serif' }}>
                    PRO
                  </span>
                )}
              </div>
              {item.locked ? (
                <button
                  onClick={() => watchAdToUnlock && watchAdToUnlock('settings')}
                  className="px-2 py-1 rounded-lg text-[10px] font-bold text-white transition-all hover:scale-105"
                  style={{ background: 'linear-gradient(135deg, #a855f7, #7c3aed)', fontFamily: 'Fredoka, sans-serif' }}
                  data-testid={`watch-ad-setting-${item.id}`}
                >
                  📺 Watch Ad
                </button>
              ) : (
                <button
                  onClick={() => item.id === 'bgm' ? item.set() : item.set(!item.value)}
                  className={`w-11 h-6 rounded-full transition-all relative ${item.value ? 'bg-emerald-500' : 'bg-slate-600'}`}
                  data-testid={`setting-${item.id}`}
                >
                  <div className={`absolute top-0.5 w-5 h-5 rounded-full bg-white shadow transition-all`}
                    style={{ left: item.value ? '22px' : '2px' }}
                  />
                </button>
              )}
            </div>
          ))}
        </div>
        <button
          onClick={onClose}
          className="w-full mt-5 py-2.5 rounded-xl bg-white/10 text-white text-sm font-semibold hover:bg-white/20 transition-all"
          style={{ fontFamily: 'Fredoka, sans-serif' }}
          data-testid="settings-close"
        >
          Done
        </button>
      </div>
    </div>
  );
};
